import { useMyInvite } from '@echo/core/react';
import { Button } from '@echo/ui-web';
import { Trans, useLingui } from '@lingui/react/macro';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GroupLoading } from '@/components/group-load-state';
import { InvitedGroupCard } from '@/components/invited-group-card';

export const Route = createFileRoute('/_app/invite/$inviteId_/joined')({
  component: JoinedGroupPage,
});

/**
 * Join group › You're in! (Figma invite, joined): the group they joined and who with, then "Go
 * to group" (Manage group) or "Not now" (back to Home).
 */
function JoinedGroupPage() {
  const { t } = useLingui();
  const navigate = useNavigate();
  const { inviteId } = Route.useParams();
  const invite = useMyInvite(inviteId);
  const invitation = invite.data;
  if (invite.isPending) return <GroupLoading />;
  if (!invitation) return null;

  const { groupName, invitedBy } = invitation;
  return (
    <div className="flex flex-col gap-section-sm">
      <div className="flex flex-col gap-content-lg">
        <h1 className="text-center text-headline-md font-bold">
          <Trans>You're in!</Trans>
        </h1>
        <p className="text-center text-body-md text-on-surface-medium">
          {invitedBy ? (
            <Trans>
              You've joined {groupName} with {invitedBy}.
            </Trans>
          ) : (
            <Trans>You've joined {groupName}.</Trans>
          )}
        </p>
        <InvitedGroupCard invitation={invitation} />
      </div>
      <div className="flex flex-wrap justify-end gap-content-sm">
        <Button variant="ghost" onClick={() => void navigate({ to: '/' })}>
          {t`Not now`}
        </Button>
        <Button
          onClick={() =>
            void navigate({ to: '/account/groups/$id', params: { id: invitation.groupActorUuid } })
          }
        >
          {t`Go to group`}
        </Button>
      </div>
    </div>
  );
}
